import {
  checkPaymentMethodsDisabled,
  validateDate,
  receiveAmount,
  receiveDynamicMCC,
  receiveItems,
  validateClickToPay,
} from "./authentication";

export default (script) => { 
  const params = {
    sellerId: script.getAttribute("data-getnet-sellerid"),
    token: script.getAttribute("data-getnet-token"),
    encrypt: script.getAttribute("data-getnet-encrypt"),
    orderId: script.getAttribute("data-getnet-orderid"),
    items: receiveItems(script.getAttribute("data-getnet-items")),
    amount: receiveAmount(
      script.getAttribute("data-getnet-recurrency"),
      script.getAttribute("data-getnet-amount")
    ),
    paymentMethodsToHide: checkPaymentMethodsDisabled(
      script.getAttribute("data-getnet-payment-methods-disabled")
    ),
    instructions: script.getAttribute("data-getnet-instructions") || "",
    installments: script.getAttribute("data-getnet-installments") || "1",
    boletoExpirationDate: validateDate(
      script.getAttribute("data-getnet-boleto-expiration-date")
    ),
    customerId: script.getAttribute("data-getnet-customerid"),
    customerFirstName: script.getAttribute("data-getnet-customer-first-name"),
    customerLastName: script.getAttribute("data-getnet-customer-last-name"),
    customerDocumentType: script.getAttribute(
      "data-getnet-customer-document-type"
    ),
    customerDocumentNumber: script.getAttribute(
      "data-getnet-customer-document-number"
    ),
    customerBirthDate: script.getAttribute("data-getnet-customer-birth-date"),
    customerObservation: script.getAttribute(
      "data-getnet-customer-observation"
    ),
    customerEmail: script.getAttribute("data-getnet-customer-email"),
    customerPhoneNumber:
      script.getAttribute("data-getnet-customer-phone-number") || "",
    customerMobileNumber:
      script.getAttribute("data-getnet-customer-mobile-number") || "",
    customerAddressStreet:
      script.getAttribute("data-getnet-customer-address-street") || "none",
    customerAddressStreetNumber:
      script.getAttribute("data-getnet-customer-address-street-number") ||
      "none",
    customerAddressComplementary:
      script.getAttribute("data-getnet-customer-address-complementary") || "",
    customerAddressNeighborhood:
      script.getAttribute("data-getnet-customer-address-neighborhood") ||
      "none",
    customerAddressCity:
      script.getAttribute("data-getnet-customer-address-city") || "none",
    customerAddressState:
      script.getAttribute("data-getnet-customer-address-state") || "",
    customerAddressZipcode:
      script.getAttribute("data-getnet-customer-address-zipcode") || "",
    customerCountry:
      script.getAttribute("data-getnet-customer-country") || "none",
    cvvHidden: JSON.parse(script.getAttribute("data-getnet-cvv-hidden")),
    cvvOptional: JSON.parse(script.getAttribute("data-getnet-cvv-optional")),
    shippingAddress:
      script.getAttribute("data-getnet-shipping-address") || null,
    urlCallback: script.getAttribute("data-getnet-url-callback") || "",
    recurrency: script.getAttribute("data-getnet-recurrency"),
    installmentStartDate: script.getAttribute(
      "data-getnet-installment-start-date"
    )
      ? script.getAttribute("data-getnet-installment-start-date")
      : null,
    planId: script.getAttribute("data-getnet-recurrency-planid"),
    recurrencyUsername: script.getAttribute("data-getnet-recurrency-username"),
    updateCard: script.getAttribute("data-getnet-update-card"),
    subscriptionId: script.getAttribute(
      "data-getnet-recurrency-subscriptionid"
    ),
    authenticatedCredit: script.getAttribute(
      "data-getnet-authenticated-credit"
    ),
    disableShippingAddress: script.getAttribute(
      "data-getnet-disable-shipping-address"
    ),
    preAuthorizationCredit: script.getAttribute(
      "data-getnet-pre-authorization-credit"
    ),
    buttonClass: script.getAttribute("data-getnet-button-class") || "",
    dynamicMcc: receiveDynamicMCC(
      script.getAttribute("data-getnet-dynamic-mcc")
    ),
    softDescriptor: script.getAttribute("data-getnet-soft-descriptor") || "",
    ourNumber: script.getAttribute("data-getnet-our-number") || "",
    documentNumber: script.getAttribute("data-getnet-document-number") || "",
    provider: script.getAttribute("data-getnet-provider") || "",
    linkId: script.getAttribute("data-getnet-link-id") || "",
    cardCaixa: script.getAttribute("data-getnet-card-caixa") || "",
    windowWidth: window.innerWidth,
    tresDSAdditionalObject: script.getAttribute(
      "data-getnet-gn3ds-additional-object"
    ),
    click2Pay: validateClickToPay({
      linkId: script.getAttribute("data-getnet-link-id"),
    }),
  };
  return params;
};



// WEBPACK FOOTER //
// ./src/params.js